import { Component, Input, OnInit } from '@angular/core';
import { Grade } from './../../models/Grade';
import { CoinsProvider } from './../../providers/coins/coins';
import { ModalController } from 'ionic-angular';
import { AddGradeComponent } from './../add-grade/add-grade';
import { Coin } from '../../models/Coin';

@Component({
    selector: 'grade-view',
    templateUrl: 'grade-view.html'
})
export class GradeViewComponent {

    @Input('grade') grade: Grade;
    @Input('withCard') withCard: boolean;

    coin: Coin;
    constructor(
        public CP: CoinsProvider,
        public modalCtrl: ModalController
    ) {

    }

    ngOnInit() {
        if(!this.grade.isStock){
            this.CP.getCoinByName(this.grade.coin).subscribe(coin => {
                this.coin = coin;
            })
        }
    }

    openGrade() {
        let modal = this.modalCtrl.create(AddGradeComponent, { grade: this.grade });
        modal.present();
    }

}



// WEBPACK FOOTER //
// ./src/components/grade-view/grade-view.ts